import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { NAV_ICONS, IconLogout } from "../../ui/icons";
import { logoutFetch } from "../../../store/authSlice";
import { getLoginPath } from "../../../utils/authRedirect";
import {
  buildStaffSidebarNav,
  resolveStaffTabId,
} from "../../../utils/staffNav";
import s from "../AdminPortal/adminApp.module.css";

export default function StaffAppMore() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { profile, role, entitlements, tenant, billing } = useSelector((state) => state.auth);
  const staffNav = buildStaffSidebarNav({ entitlements, tenant, billing });
  const activeTab = resolveStaffTabId(pathname);

  const initials = String(profile?.full_name || "?")
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const logout = () => {
    dispatch(logoutFetch());
    navigate(getLoginPath(role));
  };

  const renderLink = (item) => {
    const Icon = NAV_ICONS[item.icon] || NAV_ICONS.overview;
    const active = activeTab === item.id;
    return (
      <NavLink
        key={item.id}
        to={item.to}
        end={item.end}
        className={active ? `${s.moreListItem} ${s.moreListItemActive}` : s.moreListItem}
      >
        <span className={s.moreListIconWrap}>
          <Icon className={s.moreListIcon} />
        </span>
        <span className={s.moreListLabel}>{item.label}</span>
        <span className={s.moreListChevron} aria-hidden />
      </NavLink>
    );
  };

  return (
    <>
      <header className={s.moreHubHead}>
        <h1 className={s.moreHubTitle}>Ещё</h1>
      </header>
      <div className={s.morePage}>
        <button
          type="button"
          className={s.moreProfile}
          onClick={() => navigate("/staff/app/profile")}
        >
          <div className={s.moreAvatar} aria-hidden>
            {initials}
          </div>
          <div className={s.moreProfileInfo}>
            <p className={s.moreProfileName}>{profile?.full_name || "—"}</p>
            <p className={s.moreProfileRole}>Тренер</p>
          </div>
          <span className={s.moreProfileChevron} aria-hidden />
        </button>

        <section>
          <h2 className={s.moreSectionTitle}>Разделы</h2>
          <div className={s.moreListGroup}>{staffNav.more.map(renderLink)}</div>
        </section>

        <button type="button" className={s.moreLogout} onClick={logout}>
          <IconLogout width={18} height={18} />
          Выйти
        </button>
      </div>
    </>
  );
}
